export const ACCOUNT_TYPES = {
    SCHOOL: 'school',
    CUSTOMER: 'customer',
    DISTRICT: 'district',
} as const;

export const ACCOUNT_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
} as const;

export const ACCOUNT_TYPES_OPTIONS = (t: Function) => Object.entries(ACCOUNT_TYPES).map(([_, value]) => ({ label: t(`accounts.type.${value}`), value })) as TDropdownOption[];
export const ACCOUNT_STATUSES_OPTIONS = (t: Function) => Object.entries(ACCOUNT_STATUSES).map(([_, value]) => ({ label: t(`accounts.status.${value}`), value })) as TDropdownOption[];
